/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import { Row, Col } from 'antd';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { animated, useSpring } from 'react-spring';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import logo from '../../assets/logo/C.png';
import controle from '../../assets/images/scanner1.png';
import guichet from '../../assets/images/guichet.png';
import payway from '../../assets/images/payway.png';
import dashbord from '../../assets/images/affiliate_preview1.png';
import communicate from '../../assets/images/communiquez_sans_limite.png';
import engage from '../../assets/images/engage_your_community1.png';
import Iconify from '../Iconify';
import DashFeaure from './dash';
import CustomButton from '../CustomButton';
import LucideIcon from '../LucideIcon';

const ContainerAnim = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    paddingBottom: 40
});

const Line = styled('div')({
    display: 'flex',
    overflow: 'hidden',
});

const AnimatedBox = styled(animated.div)({
    margin: '10px',
    padding: 15,
    border: '1px solid #ccc',
    backgroundColor: 'white',
    borderRadius: '5px',
    width: 300,
    alignContent: 'center',
    textAlign: 'center',
});

function FunctionsV1() {

    return (
        <div id="work" className="block workBlock">
            <Container maxWidth="xl">
                <Stack spacing={4} >
                    <Stack paddingX={{xs:0, sm:10, md:20, lg:30, xl:40}}>
                        <Typography textAlign="center" variant="h5" sx={{ color: 'orangered' }}>
                            Fonctionnalités
                        </Typography>
                        <Typography textAlign="center" variant="h2">
                            Tout ce dont vous avez besoin <span style={{color: '#5E17EB'}}>pour réussir</span>
                        </Typography>
                        <Typography textAlign="center" color="text.secondary" fontSize={20}>
                            Une plateforme complète pour vendre, promouvoir et gérer vos événements en toute simplicité.
                        </Typography>
                    </Stack>


                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 3 }}>
                        <Card sx={{ padding: 4, border: '1px solid #f2f2f2', borderRadius: '10px', width: '100%' }}>
                            <Stack spacing={1.5} justifyContent={'start'} alignItems={'start'}>
                                <Box sx={{ borderRadius: '10px', bgcolor: '#5e17eb09' }} padding={1}>
                                    <LucideIcon name='Ticket'  strokeWidth={'2'} size={40} color={'#5E17EB'}/>
                                </Box>

                                <Typography fontSize={22} fontWeight={550}>
                                    Billetterie Intuitive
                                </Typography>
                                <Typography color="text.secondary" fontSize={18}>
                                    Créez et gérez vos événements en quelques minutes avec une interface conviviale et des options de personnalisation étendues.
                                </Typography>
                            </Stack>
                        </Card>
                        <Card sx={{ padding: 4, border: '1px solid #f2f2f2', borderRadius: '10px', width: '100%' }}>
                            <Stack spacing={1.5} justifyContent={'start'} alignItems={'start'}>
                                <Box sx={{ borderRadius: '10px', bgcolor: '#5e17eb09' }} padding={1}>
                                    <LucideIcon name='Megaphone'  strokeWidth={'2'} size={40} color={'#5E17EB'}/>
                                </Box>

                                <Typography fontSize={22} fontWeight={550}>
                                    Marketing Intégré
                                </Typography>
                                <Typography color="text.secondary" fontSize={18}>
                                    Engagez votre audience avec des campagnes e-mail, push et réseaux sociaux directement depuis la plateforme.
                                </Typography>
                            </Stack>
                        </Card>
                        <Card sx={{ padding: 4, border: '1px solid #f2f2f2', borderRadius: '10px', width: '100%' }}>
                            <Stack spacing={1.5} justifyContent={'start'} alignItems={'start'}>
                                <Box sx={{ borderRadius: '10px', bgcolor: '#5e17eb09' }} padding={1}>
                                    <LucideIcon name='Users'  strokeWidth={'2'} size={40} color={'#5E17EB'}/>
                                </Box>

                                <Typography fontSize={22} fontWeight={550}>
                                    Affiliation & Partenaires
                                </Typography>
                                <Typography color="text.secondary" fontSize={18}>
                                    Collaborez avec des influenceurs et partenaires pour augmenter votre visibilité et vos ventes.
                                </Typography>
                            </Stack>
                        </Card>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 3 }}>
                        <Card sx={{ padding: 4, border: '1px solid #f2f2f2', borderRadius: '10px', width: '100%' }}>
                            <Stack spacing={1.5} justifyContent={'start'} alignItems={'start'}>
                                <Box sx={{ borderRadius: '10px', bgcolor: '#5e17eb09' }} padding={1}>
                                    <LucideIcon name='ChartColumn'  strokeWidth={'2'} size={40} color={'#5E17EB'}/>
                                </Box>

                                <Typography color="text.primary" fontSize={22} fontWeight={550}>
                                    Analyses Détaillées
                                </Typography>
                                <Typography color="text.secondary" fontSize={18}>
                                    Suivez vos ventes en temps réel et accédez à des statistiques complètes sur votre audience.
                                </Typography>
                            </Stack>
                        </Card>
                        <Card sx={{ padding: 4, border: '1px solid #f2f2f2', borderRadius: '10px', width: '100%' }}>
                            <Stack spacing={1.5} justifyContent={'start'} alignItems={'start'}>
                                <Box sx={{ borderRadius: '10px', bgcolor: '#5e17eb09' }} padding={1}>
                                    <LucideIcon name='Shield' strokeWidth={'2'} size={40} color={'#5E17EB'}/>
                                </Box>

                                <Typography fontSize={22} fontWeight={550}>
                                    Sécurité Maximale
                                </Typography>
                                <Typography color="text.secondary" fontSize={18}>
                                    Protection optimale de vos données avec sauvegarde et redondance des services.
                                </Typography>
                            </Stack>
                        </Card>
                        <Card sx={{ padding: 4, border: '1px solid #f2f2f2', borderRadius: '10px', width: '100%' }}>
                            <Stack spacing={1.5} justifyContent={'start'} alignItems={'start'}>
                                <Box sx={{ borderRadius: '10px', bgcolor: '#5e17eb09' }} padding={1}>
                                    <LucideIcon name='Zap' strokeWidth={'2'} size={40} color={'#5E17EB'}/>
                                </Box>

                                <Typography fontSize={22} fontWeight={550}>
                                    Revente Sécurisée
                                </Typography>
                                <Typography color="text.secondary" fontSize={18}>
                                    Outil intégré de revente pour lutter contre le marché noir, très apprécié par nos utilisateurs.
                                </Typography>
                            </Stack>
                        </Card>
                    </Stack>
                </Stack>
            </Container>
        </div>
    );
}

export default FunctionsV1;
